import React, { Component } from "react"
import { Modal, Button, Spinner, ProgressBar } from "react-bootstrap"
import uploadService from "./uploadService"
import "./PhotoUploader.css"

export interface PhotoUploaderProps {
    title: string
    refresher: Function
    photoDex: number
    toggler: Function
    progressToggler?: any
    hashed: boolean
    requestBody: any
    multiple: boolean
}

type PhotoUploaderTypes = {
    imagePreviews: Array<any>
    panDex: number
    image: any
    hasImages: boolean
    showNewPhotoConfirm: boolean
    addingPhoto: boolean
    uploadProgress: number
    currentFile: number
}

class PhotoUploader extends Component<PhotoUploaderProps, PhotoUploaderTypes> {

    images = [{ type: "Other", image: "", blob: "" }]
    uploadDex = -1
    photoDex = this.props.photoDex

    constructor(props: PhotoUploaderProps) {
        super(props)
        this.state = {
            imagePreviews: this.images,
            panDex: 0,
            image: "",
            hasImages: false,
            showNewPhotoConfirm: false,
            addingPhoto: false,
            uploadProgress: 5,
            currentFile: 0
        }
    }

    componentDidMount() {
        uploadService.base64images = []
    }

    uploadPictures = () => {
        if (this.props.multiple) {
            const self = this
            setTimeout(function () {
                if (uploadService.progress.fileProgress === 0) {
                    self.uploadDex++;
                    if (self.uploadDex < self.state.imagePreviews.length - 1) {
                        const date = new Date()
                        self.photoDex += 1
                        let index = self.photoDex
                        index += 1
                        let requestBody = self.props.requestBody
                        //@ts-ignore
                        requestBody.TimeStamp = uploadService.base64images[self.uploadDex].date
                        requestBody.UTCOffset = date.getTimezoneOffset()
                        //@ts-ignore
                        requestBody.ClientImageKey = uploadService.base64images[self.uploadDex].date + ""
                        //@ts-ignore
                        requestBody.Base64Img = uploadService.base64images[self.uploadDex].Base64Img
                        requestBody.Index = index
                        if (self.props.hashed) {
                            //@ts-ignore
                            requestBody.ClientImageKey = uploadService.generateHash(uploadService.base64images[self.uploadDex].Base64Img)
                        }
                        uploadService.setRequestbody(requestBody)
                        uploadService.upload()
                        self.setState({ addingPhoto: true, panDex: self.uploadDex })
                        self.uploadPictures()
                    }
                } else {
                    self.uploadPictures()
                }
            }, 500)
        } else {
            const date = new Date()
            let requestBody = this.props.requestBody
            //@ts-ignore
            requestBody.TimeStamp = uploadService.base64images[0].date
            requestBody.UTCOffset = date.getTimezoneOffset()
            //@ts-ignore
            requestBody.ClientImageKey = uploadService.base64images[0].date + ""
            //@ts-ignore
            requestBody.Base64Img = uploadService.base64images[0].Base64Img
            requestBody.Index = 0
            if (this.props.hashed) {
                //@ts-ignore
                requestBody.ClientImageKey = uploadService.generateHash(uploadService.base64images[0].Base64Img)
            }
            uploadService.setRequestbody(requestBody)
            uploadService.upload()
            this.checkUploadProgress()
            this.setState({ addingPhoto: true, panDex: 0 })
        }
    }

    prepUpload = () => {
        this.setState({ panDex: 0 })
        this.checkUploadProgress()
        this.uploadPictures()
        if (this.props.progressToggler) {
            this.props.progressToggler()
        }
    }

    checkUploadProgress = () => {
        //r-18-lint-bk
        // eslint-disable-next-line
        let success = 0
        const self = this
        const interval = setInterval(function () {
            if (uploadService.progress.filesLeft === 0) {
                success++
                clearInterval(interval)
                self.props.refresher()
                self.props.toggler()
                if (self.props.progressToggler) {
                    self.props.progressToggler()
                }
            } else {
                if (uploadService.progress.fileProgress !== self.state.uploadProgress || uploadService.progress.filesLeft !== self.state.currentFile) {
                    self.setState({ uploadProgress: uploadService.progress.fileProgress, currentFile: uploadService.progress.filesLeft })
                }
            }
        }, 50);
    }

    prepImage = (event: any) => {
        if (event.target.files[0]) {
            let img = event.target.files[0];
            uploadService.addImage(event.target.files[0])
            this.addImage(URL.createObjectURL(img))
        }
    }

    addImage = (img: any) => {
        this.images[this.state.panDex].image = img
        this.setState({ imagePreviews: this.images })
        this.lengthCheck()
        if (this.props.multiple) {
            this.panPreview("+")
        } else {
            this.panPreview("-")
        }
    }

    lengthCheck = () => {
        if (this.props.multiple) {
            let validcount = 0
            for (let i = 0; i < this.state.imagePreviews.length; i++) {
                if (this.state.imagePreviews[i].image.length > 0) {
                    validcount = validcount + 1
                }
            }
            if (validcount > this.state.imagePreviews.length - 1) {
                let temp = this.state.imagePreviews
                temp.push({ type: "Other", image: "", blob: "" })
                this.setState({ hasImages: true, imagePreviews: temp })
            } else {
                this.setState({ hasImages: false })
            }
        } else {
            if (this.state.imagePreviews[0].image.length > 0) {
                this.setState({ hasImages: true })
            }
        }

    }

    panPreview = (direction: string) => {
        if (direction === "+") {
            if (this.state.panDex < this.state.imagePreviews.length - 1) {
                this.setState({ panDex: this.state.panDex + 1 })
            }
        } else {
            if (this.state.panDex > 0) {
                this.setState({ panDex: this.state.panDex - 1 })
            }
        }
    }

    toggleConfirm = () => {
        if (this.state.showNewPhotoConfirm) {
            this.setState({ showNewPhotoConfirm: false })
        } else {
            this.setState({ showNewPhotoConfirm: true })
        }
    }

    render() {

        //console.log(this.state.imagePreviews)

        return (
            <div className="PhotoUploader">
                <Modal id="fleet-photo-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    size="xl"
                >
                    <Modal.Header>
                        <Modal.Title>{this.props.title}</Modal.Title>
                    </Modal.Header>
                    {this.state.showNewPhotoConfirm && <div className="UploadPhotosConfirm">
                        <Modal
                            show={true}
                            backdrop="static"
                            keyboard={true}
                        >
                            {!this.state.addingPhoto && <Modal.Header>
                                <Modal.Title>Confirm Upload?</Modal.Title>
                            </Modal.Header>}
                            {this.state.addingPhoto && <Modal.Body>
                                <div className="Add-Photo-Uploading-Wrapper">
                                    <p id="add-photo-files-left">Files Left: {this.state.currentFile}</p>
                                    <ProgressBar id="add-photo-progress-bar" now={this.state.uploadProgress} label={`${this.state.uploadProgress}%`} />
                                </div>
                            </Modal.Body>}
                            <Modal.Footer>
                                {!this.state.addingPhoto && <Button variant="primary" onClick={() => this.prepUpload()}>Upload</Button>}
                                {this.state.addingPhoto && <Button id="add-Photo-is-loading-btn" disabled={true} variant="primary" onClick={() => this.prepUpload()}>Uploading<Spinner id="add-photo-spinner" animation="border" /></Button>}
                                <Button variant="secondary" onClick={() => this.toggleConfirm()}>Cancel</Button>
                            </Modal.Footer>
                        </Modal>
                    </div>}
                    <div className="Exit-New-Photo-View" onClick={() => this.props.toggler()}>
                        <span className="material-icons">close</span>
                    </div>
                    {this.props.multiple && <div className="New-Photo-Pan-Btns">
                        <div id="add-photo-pan-left">
                            <span className="material-icons" onClick={() => this.panPreview("-")}>keyboard_arrow_left</span>
                        </div>
                        <div id="add-photo-pan-right">
                            <span className="material-icons" onClick={() => this.panPreview("+")}>keyboard_arrow_right</span>
                        </div>
                    </div>}
                    {this.props.multiple && <div className="Add-Photo-Image-Preview">
                        {this.state.imagePreviews[this.state.panDex].image !== "" && <img src={this.state.imagePreviews[this.state.panDex].image} alt=""></img>}
                        {this.state.imagePreviews[this.state.panDex].image === "" && <span className="material-icons-outlined">photo_size_select_large</span>}
                    </div>}
                    {!this.props.multiple && <div className="Add-Photo-Image-Preview">
                        {this.state.imagePreviews.length > 0 && this.state.imagePreviews[this.state.panDex].image !== "" && <img src={this.state.imagePreviews[this.state.panDex].image} alt=""></img>}
                        {this.state.imagePreviews[0].image === "" && <span className="material-icons-outlined">photo_size_select_large</span>}
                    </div>}
                    {this.props.multiple && <div className="Add-Photo-Image-Carousel">
                        {this.state.imagePreviews.map((img, i) =>
                            <div className="Add-Photo-Image-Carousel-Wrapper" key={i}>
                                {this.state.panDex !== i && <div className="add-photo-Image-Carousel-image-wrapper-not-focused" key={"add-photo-image-carousel-image-not-focused" + i}>
                                    {img.image !== "" && <img src={img.image} alt=""></img>}
                                    {img.image === "" && <span className="material-icons-outlined">insert_photo</span>}
                                </div>}
                                {this.state.panDex === i && <div className="add-photo-Image-Carousel-image-wrapper-focused" key={"add-Photo-image-carousel-image-focused" + i}>
                                    {img.image !== "" && <img src={img.image} alt=""></img>}
                                    {img.image === "" && <span className="material-icons-outlined">insert_photo</span>}
                                </div>}
                            </div>
                        )}
                    </div>}
                    {!this.state.showNewPhotoConfirm && <div className="new-photo-custom-file-upload-wrapper">
                        <label className="new-photo-custom-file-upload">
                            Choose File
                            <input id="ChooseFile" type="file" onChange={this.prepImage} />
                        </label>
                        {this.state.hasImages && <Button id="new-photo-next-btn" variant="primary" onClick={() => this.toggleConfirm()}>Next</Button>}
                    </div>}
                </Modal>
            </div>
        )
    }
}

export default PhotoUploader;